// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAMPQ6icC-faxi-zNZvLrJZm7jEqKBNQEA",
    authDomain: "bioncarbon.firebaseapp.com",
    projectId: "bioncarbon",
    storageBucket: "bioncarbon.firebasestorage.app",
    messagingSenderId: "207859944131",
    appId: "1:207859944131:web:3d41221d971daeaf06b076",
    measurementId: "G-NNF60JY8HT"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
